import { render, staticRenderFns } from "./bind-sa.vue?vue&type=template&id=e343859e&lang=pug&"
import script from "./bind-sa.vue?vue&type=script&lang=js&"
export * from "./bind-sa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports